"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
require("./Slider.scss");
_reactSlick["default"].defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return /*#__PURE__*/_react["default"].createElement("ul", {
      style: {
        display: 'block'
      }
    }, dots);
  },
  arrows: true,
  asNavFor: undefined,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: '50px',
  className: '',
  cssEase: 'ease',
  customPaging: function customPaging(i) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button"
    }, i + 1);
  },
  dots: false,
  dotsClass: 'slick-dots',
  draggable: true,
  easing: 'linear',
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: 'div',
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};
_reactSlick["default"].propTypes = {
  accessibility: _propTypes["default"].bool,
  adaptiveHeight: _propTypes["default"].bool,
  afterChange: _propTypes["default"].func,
  appendDots: _propTypes["default"].func,
  arrows: _propTypes["default"].bool,
  asNavFor: _propTypes["default"].oneOfType([_propTypes["default"].func,
  // eslint-disable-next-line react/forbid-prop-types
  _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  autoplay: _propTypes["default"].bool,
  autoplaySpeed: _propTypes["default"].number,
  beforeChange: _propTypes["default"].func,
  centerMode: _propTypes["default"].bool,
  centerPadding: _propTypes["default"].string,
  className: _propTypes["default"].string,
  cssEase: _propTypes["default"].string,
  customPaging: _propTypes["default"].func,
  dots: _propTypes["default"].bool,
  dotsClass: _propTypes["default"].string,
  draggable: _propTypes["default"].bool,
  easing: _propTypes["default"].string,
  edgeFriction: _propTypes["default"].number,
  fade: _propTypes["default"].bool,
  focusOnSelect: _propTypes["default"].bool,
  infinite: _propTypes["default"].bool,
  initialSlide: _propTypes["default"].number,
  lazyLoad: _propTypes["default"].string,
  nextArrow: _propTypes["default"].element,
  onEdge: _propTypes["default"].func,
  onInit: _propTypes["default"].func,
  onLazyLoadError: _propTypes["default"].func,
  onReInit: _propTypes["default"].func,
  pauseOnDotsHover: _propTypes["default"].bool,
  pauseOnFocus: _propTypes["default"].bool,
  pauseOnHover: _propTypes["default"].bool,
  prevArrow: _propTypes["default"].element,
  responsive: _propTypes["default"].arrayOf({
    breakpoint: _propTypes["default"].number,
    settings: _propTypes["default"].object
  }),
  rows: _propTypes["default"].number,
  rtl: _propTypes["default"].bool,
  slide: _propTypes["default"].string,
  slidesPerRow: _propTypes["default"].number,
  slidesToScroll: _propTypes["default"].number,
  slidesToShow: _propTypes["default"].number,
  speed: _propTypes["default"].number,
  swipe: _propTypes["default"].bool,
  swipeEvent: _propTypes["default"].func,
  swipeToSlide: _propTypes["default"].bool,
  touchMove: _propTypes["default"].bool,
  touchThreshold: _propTypes["default"].number,
  useCSS: _propTypes["default"].bool,
  useTransform: _propTypes["default"].bool,
  variableWidth: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  waitForAnimate: _propTypes["default"].bool
};
var _default = exports["default"] = _reactSlick["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Slider.js
// module id = 1514
// module chunks = 25